export default __webpack_public_path__ + "static/media/cardiacMonitoring.7efcf6dd.svg";